export function uniqueDevices (data) {
  return data.filter((item, index, arr) =>
     arr.findIndex((x) => x?.DeviceId === item?.DeviceId) === index)
}

export function uniqueLinks (data, uniques) {
  const xxx = data.filter(d => 
    d?.DestAdrs !== uniques.find(u => u?.DeviceId === d?.DeviceId)?.DestAdrs)
  console.log (xxx)
}

export function uniqueCombo (data) {
  return data?.filter ((item, index, arr) =>
    index === arr.findIndex (x => 
      x?.DeviceId === item?.DeviceId && x.DestAdrs === item.DestAdrs)
  ) ?? []
}
export function linkPartners (data, radioId) {
  const valid = validMsgs(data)
  return valid.filter(i => i.DeviceId.toUpperCase() === radioId)
}
const linkStatusValidDest = ["80", "81", "82", "84", "85", "88", "89",]
function validMsgs (data) {
  return data.filter(i=>linkStatusValidDest.includes(i?.MsgType))
}
